import React, { useState, useEffect } from "react";

const Services = () => {
  const [activeTab, setActiveTab] = useState("Software Development");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 800);
    return () => clearTimeout(timer);
  }, [activeTab]);

  const data = {
    "Software Development": [
      {
        title: "Custom Applications",
        desc: "Building tailored desktop, web, and mobile applications that address unique business needs with scalable and secure architectures.",
        color: "#e3f2fd",
      },
      {
        title: "Cloud-Native Solutions",
        desc: "Designing and deploying applications on AWS, Azure, and Google Cloud to ensure flexibility, performance, and cost efficiency.",
        color: "#fff3e0",
      },
      {
        title: "Agile Product Engineering",
        desc: "Accelerating software delivery cycles through Agile and DevOps practices with continuous integration and deployment.",
        color: "#f3e5f5",
      },
    ],
    "Digital Platforms": [
      {
        title: "E-Commerce Platforms",
        desc: "Developing robust e-commerce solutions with payment gateways, personalized recommendations, and secure transactions.",
        color: "#e8f5e9",
      },
      {
        title: "Enterprise Portals",
        desc: "Creating centralized platforms for businesses to manage operations, customers, and employees efficiently.",
        color: "#fce4ec",
      },
      {
        title: "Learning Management Systems (LMS)",
        desc: "Delivering digital education platforms with interactive content, assessments, and analytics for institutions and enterprises.",
        color: "#ede7f6",
      },
    ],
    "Emerging Technologies": [
      {
        title: "AI & Machine Learning",
        desc: "Integrating AI-driven chatbots, recommendation systems, and predictive analytics into digital platforms.",
        color: "#fff9c4",
      },
      {
        title: "Blockchain Solutions",
        desc: "Building secure and transparent digital ecosystems with blockchain-based financial and supply chain platforms.",
        color: "#c8e6c9",
      },
      {
        title: "IoT & Smart Platforms",
        desc: "Connecting devices and sensors to build intelligent ecosystems for industries, healthcare, and smart cities.",
        color: "#ffcdd2",
      },
    ],
  };

  const styles = {
    container: {
      padding: "40px",
      fontFamily: "Arial, sans-serif",
      maxWidth: "100%",
      margin: "0 auto",
      backgroundColor: "white",
    },
    heading: {
      fontSize: "36px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "left",
      letterSpacing: "0px",
    },
    tabs: {
      display: "flex",
      gap: "30px",
      marginBottom: "30px",
      flexWrap: "wrap",
    },
    tab: (isActive) => ({
      fontSize: "18px",
      fontWeight: isActive ? "bold" : "normal",
      cursor: "pointer",
      borderBottom: isActive ? "2px solid red" : "none",
      color: isActive ? "#000" : "gray",
      paddingBottom: "5px",
      transition: "0.3s",
    }),
    cards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
    },
    card: (bgColor, index) => ({
      background: bgColor,
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      transform: animate
        ? `translateY(${index % 2 === 0 ? "30px" : "-30px"})`
        : "translateY(0)",
      opacity: animate ? 0 : 1,
      animation: animate ? `waveIn 0.8s ease forwards ${index * 0.2}s` : "none",
      minHeight: "230px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    }),
    cardTitle: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "15px",
      letterSpacing: "0px",
    },
    cardText: {
      fontSize: "16px",
      lineHeight: "1.5",
      marginBottom: "15px",
      flexGrow: 1,
      textAlign: "justify",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Software & Digital Platform Services</h1>

      {/* Tabs */}
      <div style={styles.tabs}>
        {Object.keys(data).map((tab) => (
          <div
            key={tab}
            style={styles.tab(activeTab === tab)}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {/* Cards */}
      <div style={styles.cards}>
        {data[activeTab].map((item, index) => (
          <div key={index} style={styles.card(item.color, index)}>
            <div>
              <h2 style={styles.cardTitle}>{item.title}</h2>
              <p style={styles.cardText}>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Inline keyframes */}
      <style>
        {`
          @keyframes waveIn {
            0% { transform: translateY(50px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          
          @media (max-width: 768px) {
            .services-container {
              padding: 20px;
            }
            
            .services-heading {
              font-size: 28px;
            }
            
            .services-tabs {
              gap: 15px;
            }
            
            .services-cards {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Services;
